import type { Community } from '@communities/community/domain';
import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';
import { PageHeader } from '@soteria/design-system-ve';

/**
 * Build the subheader text with community group, content rating, and genres
 */
function buildSubheaderText(community: Community): string {
  const subheaderParts: string[] = [];

  if (community.communityGroup?.name) {
    subheaderParts.push(community.communityGroup.name);
  }

  if (community.optionalMetadata?.contentRating?.description) {
    subheaderParts.push(community.optionalMetadata.contentRating.description);
  }

  if (community.optionalMetadata?.contentGenres && community.optionalMetadata.contentGenres.length > 0) {
    subheaderParts.push(community.optionalMetadata.contentGenres.join(', '));
  }

  return subheaderParts.join(' • ');
}

interface CommunityHeaderSectionProps {
  community: Community;
}

/**
 * Header section component for community pages.
 * Renders a PageHeader with the community name and metadata subtitle.
 */
function CommunityHeaderSectionComponent({ community }: CommunityHeaderSectionProps) {
  const { name } = community;
  const subheaderText = buildSubheaderText(community);

  return <PageHeader data-testid="community-header-v2" subtitle={subheaderText || undefined} title={name} />;
}

export const CommunityHeaderSection = withAppInsightsTracking(CommunityHeaderSectionComponent, 'CommunityHeaderSection');
